// extracted by mini-css-extract-plugin
export default {"container":"TeacherHome_container__cnG4e","tile":"TeacherHome_tile__xVv+o","tileTop":"TeacherHome_tileTop__N00PC"};